import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function setAdminToken(token) {
  if (token) localStorage.setItem("mme_admin_token", token);
  else localStorage.removeItem("mme_admin_token");
}
export function getAdminToken() {
  return localStorage.getItem("mme_admin_token");
}
export function setVendorToken(token) {
  if (token) localStorage.setItem("mme_vendor_token", token);
  else localStorage.removeItem("mme_vendor_token");
}
export function getVendorToken() {
  return localStorage.getItem("mme_vendor_token");
}
export function setCustomerToken(token) {
  if (token) localStorage.setItem("bme_customer_token", token);
  else localStorage.removeItem("bme_customer_token");
}
export function getCustomerToken() {
  return localStorage.getItem("bme_customer_token");
}

api.interceptors.request.use((config) => {
  const url = config.url || "";
  if (url.includes("/admin/") && !url.includes("/admin/login")) {
    const token = getAdminToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } else if (url.includes("/vendor/") && !url.includes("/vendor/login")) {
    const token = getVendorToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } else if (
    url.startsWith("/customer/") &&
    !url.includes("/customer/login") &&
    !url.includes("/customer/register")
  ) {
    const token = getCustomerToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } else if (url === "/bookings") {
    const token = getCustomerToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } else if (url.includes("/upload")) {
    const token = getVendorToken() || getAdminToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Resolve stored image references (relative /api/files/... paths) to absolute URLs.
export function imgUrl(src) {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  if (src.startsWith("/api")) return `${BACKEND_URL}${src}`;
  return src;
}

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });
